<template>
  <footer class="py-3 px-6 text-center text-xs text-on-surface-variant/60 font-body border-t border-surface-container-high bg-surface-container-lowest">
    <span>Wiazary-System</span>
    <span class="mx-2">·</span>
    <span>wersja 1.1.3</span>
  </footer>
</template>

<script>
export default { name: "AppFooter" }
</script>
